// @storybook-skip: internal section of ScreenHeaderBar; covered by its screen story
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";

type Props = {
	title?: string;
	subtitle?: string;
	titleContent?: React.ReactNode;
};

export const HeaderTitleSection = ({
	title,
	subtitle,
	titleContent,
}: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	if (titleContent) {
		return (
			<Box flex={1} minHeight={40} justifyContent="center">
				{titleContent}
			</Box>
		);
	}

	if (!(title || subtitle)) {
		return null;
	}

	return (
		<Box flex={1} gap={4}>
			{title ? (
				<Box minHeight={40} justifyContent="center">
					<Text
						variant={isMobile ? "titleLarge" : "headlineSmall"}
						numberOfLines={1}
					>
						{title}
					</Text>
				</Box>
			) : null}
			{subtitle ? (
				<Text
					variant="bodySmall"
					style={{ color: theme.colors.onSurfaceVariant }}
				>
					{subtitle}
				</Text>
			) : null}
		</Box>
	);
};
